// Iter 88o — Shared helpers extracted from JobBoard.jsx so sub-components
// don't have to re-declare them. `fmt` renders an ISO date as a short
// locale string; `fmtSize` renders a byte count as B/KB/MB.

export const fmt = (iso) => (iso ? new Date(iso).toLocaleString(undefined,
  { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export const fmtSize = (n) => {
  if (!n) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(2)} MB`;
};
